/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import ModalTemplate from '../../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../../Global/Localize'
import Tab from '../../../../../Components/Tabs/Tab'
import IAEntries from './IAEntries'
import { getData } from '../../../../../Helpers/webApi'
import DynamicCharges from '../../../../../Components/Selectables/Plain/DynamicCharges'
import { formatDate } from '../../../../../Helpers/formatters'
import Loader from '../../../../../Components/Loaders/Loader'

function ViewInterAccountTransferDataModal({
  mode,
  selectedInterAccountTransferBatch,
  closeModal,
  dynamicChargesToBeSelected,
}) {
  const [isBusy, setIsBusy] = useState(false)
  const [apportionedAmount, setApportioned] = useState(null)
  const [shortageAmount, setShortage] = useState(null)
  const [entries, setEntries] = useState([])
  const [reqParams, setReqParams] = useState({
    status: 1,
    filterText: '',
    interAccountTransferBatchEntryFilter: 0,
    pageIndex: 0,
    pageSize: 10,
  })

  const loadEntries = async () => {
    setIsBusy(true)
    const { success, data } = await getData(
      `/InterAccountTransferBatch/find-inter-account-transfer-batch-entries-by-inter-account-transfer-batch-id-in-page`,
      {
        interAccountTransferBatchId: selectedInterAccountTransferBatch.id,
        ...reqParams,
      },
      false
    )
    if (success) {
      setIsBusy(false)
      setEntries(data.pageCollection)
      setApportioned(data.totalApportioned)
      setShortage(data.totalShortage)
    } else {
      setEntries([])
    }
    setIsBusy(false)
  }

  useEffect(() => {
    loadEntries()
    // eslint-disable-next-line
  }, [
    selectedInterAccountTransferBatch?.id,
    reqParams.pageSize,
    reqParams.pageIndex,
  ])

  return (
    <>
      <ModalTemplate
        modalMode={mode}
        modalTitle={localize('InterAccountTransfers')}
        handleClose={closeModal}
        modalClassName="modal-xl"
        handleAction={() => {}}
        actionText={mode === 'view' ? 'refresh' : ''}
        footerChildren={
          <>
            {mode === 'view' ? (
              <>
                <div className="col-3 d-flex align-items-center">
                  <label className="col-3 text-capitalize">
                    {localize('apportioned')}
                  </label>
                  <input
                    type="text"
                    className="form-control ms-2"
                    disabled
                    value={apportionedAmount || ''}
                  />
                </div>

                <div className="col-3 d-flex align-items-center">
                  <label className="col-3 text-capitalize">
                    {localize('shortage')}
                  </label>
                  <input
                    type="text"
                    className="form-control ms-2"
                    disabled
                    value={shortageAmount || ''}
                  />
                </div>
              </>
            ) : (
              ''
            )}
          </>
        }
      >
        {isBusy ? (
          <Loader />
        ) : (
          <>
            <div className="row mb-2">
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('batchNumber')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.batchNumber || ''}
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('batchType')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    selectedInterAccountTransferBatch?.typeDescription || ''
                  }
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center ">
                <label className="col-3 text-capitalize">
                  {localize('remarks')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.remarks || ''}
                  disabled
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('createdBy')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.createdBy || ''}
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('createdDate')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    formatDate(
                      selectedInterAccountTransferBatch?.createdDate
                    ) || ''
                  }
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('priority')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    selectedInterAccountTransferBatch?.priorityDescription || ''
                  }
                  disabled
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('verifiedBy')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.auditedBy || ''}
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('verifiedDate')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    formatDate(
                      selectedInterAccountTransferBatch?.auditedDate,
                      true
                    ) || ''
                  }
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('verificationRemarks')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.auditRemarks || ''}
                  disabled
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('authorizedBy')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={selectedInterAccountTransferBatch?.authorizedBy || ''}
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('authorizedDate')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    formatDate(
                      selectedInterAccountTransferBatch?.authorizedDate,
                      true
                    ) || ''
                  }
                  disabled
                />
              </div>
              <div className="col d-flex align-items-center">
                <label className="col-3 text-capitalize">
                  {localize('authorizationRemarks')}
                </label>
                <input
                  type="text"
                  className="form-control me-3"
                  value={
                    selectedInterAccountTransferBatch?.authorizationRemarks ||
                    ''
                  }
                  disabled
                />
              </div>
            </div>
            <div className="row col-12 mt-2">
              <Tab
                tabItems={[
                  {
                    label: localize('batchEntries'),
                    item: (
                      <IAEntries
                        mode={mode}
                        unpostedEntries={entries}
                        entries={entries}
                        setApportioned={setApportioned}
                        setShortage={setShortage}
                      />
                    ),
                  },
                  {
                    label: localize('indefiniteCharges'),
                    item: (
                      <DynamicCharges
                        prefix={'create-inter-acc-transfer-dynamic-charges'}
                        dynamicChargesToBeSelected={dynamicChargesToBeSelected}
                        disabled
                      />
                    ),
                  },
                ]}
              />
            </div>
          </>
        )}
      </ModalTemplate>
    </>
  )
}
export default ViewInterAccountTransferDataModal
